export const partnerPlatformBaseUrl = import.meta.env.VITE_PARTNER_PLATFORM_API_URL || "http://localhost:3004";
export const cognitoUserPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID || "us-east-2_Ek6LxwN3L";
export const cognitoOauthDomain = import.meta.env.VITE_COGNITO_OAUTH_DOMAIN || "staging-login-partners.bounceai.com";
